import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { gql } from '@apollo/client';
import { makeDecodedQuery } from '@infl-ts/util-make-apollo-decoded';
import * as t from 'io-ts';
export var useProfileQuery = makeDecodedQuery(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query ProfileForDatadogConfig {\n      profile {\n        id\n        isAdmin\n        isClone\n      }\n    }\n  "]))), t.type({
  profile: t.type({
    id: t.string,
    isAdmin: t["boolean"],
    isClone: t["boolean"]
  })
}));